import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { DataService } from './services/data.service';

// import ngx-translate and the http loader
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import { NgxCarouselModule } from 'ngx-carousel';
import 'hammerjs';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CarouselComponent } from './components/home/carousel/carousel.component';
import { AdvantageComponent } from './components/home/advantage/advantage.component';
import { AchievementComponent } from './components/home/achievement/achievement.component';
import { MentorsComponent } from './components/home/mentors/mentors.component';
import { CasesComponent } from './components/home/cases/cases.component';
import { NewsComponent } from './components/home/news/news.component';
import { PartnersComponent } from './components/home/partners/partners.component';
import { FooterComponent } from './components/footer/footer.component';
import { AboutUsComponent } from './components/about/about-us/about-us.component';
import { HomeComponent } from './components/home/home/home.component';
import { UsLifeComponent } from './components/us-life/us-life/us-life.component';
import { MentorPageComponent } from './components/mentor/mentor-page/mentor-page.component';
import { CareerComponent } from './components/career/career/career.component';
import { SubnavComponent } from './components/education-and-career/subnav/subnav.component';
import { EvaluationComponent } from './components/education-and-career/evaluation/evaluation.component';
import { ProdSystemComponent } from './components/education-and-career/prod-system/prod-system.component';
import { EducationComponent } from './components/education/education/education.component';
import { ProjectsComponent } from './components/education/projects/projects.component';
import { EducationMainComponent } from './components/education/education-main/education-main.component';
import { CareerMainComponent } from './components/career/career-main/career-main.component';
import { CareerProjectsComponent } from './components/career/career-projects/career-projects.component';
import { JobsComponent } from './components/job/jobs/jobs.component';



@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    CarouselComponent,
    AdvantageComponent,
    AchievementComponent,
    MentorsComponent,
    CasesComponent,
    NewsComponent,
    PartnersComponent,
    FooterComponent,
    AboutUsComponent,
    HomeComponent,
    UsLifeComponent,
    MentorPageComponent,
    CareerComponent,
    SubnavComponent,
    EvaluationComponent,
    ProdSystemComponent,
    EducationComponent,
    ProjectsComponent,
    EducationMainComponent,
    CareerMainComponent,
    CareerProjectsComponent,
	JobsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxCarouselModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/app.module.ts